import { request, makePath } from './http';
const API_NAME = 'notify';

export function getWebsocket() {
  return request('GET', makePath(API_NAME, 'ws'));
}
